module.exports = __webpack_public_path__ + "static/img/record.93666823.png";